import {
  DOG_TYPE_INFO,
  DOG_TYPE_LABELS,
  MAIN_PET_TYPE_LABELS,
  MAIN_PET_TYPE_NAMES,
  PET_TYPE_LABELS,
  PET_TYPE_NAMES,
} from '~/common/constants/app';

export const MAIN_PET_TYPE_OPTIONS = [
  {
    label: MAIN_PET_TYPE_LABELS.PUPPY,
    name: MAIN_PET_TYPE_NAMES.PUPPY,
    value: MAIN_PET_TYPE_NAMES.PUPPY,
    description: 'Under 6 months',
  },
  {
    label: MAIN_PET_TYPE_LABELS.DOG,
    name: MAIN_PET_TYPE_NAMES.DOG,
    value: MAIN_PET_TYPE_NAMES.DOG,
    description: 'Over 6 months',
  },
  {
    label: MAIN_PET_TYPE_LABELS.CAT,
    name: MAIN_PET_TYPE_NAMES.CAT,
    value: MAIN_PET_TYPE_NAMES.CAT,
    description: 'Including kittens',
  },
  {
    label: MAIN_PET_TYPE_LABELS.OTHER,
    name: MAIN_PET_TYPE_NAMES.OTHER,
    value: MAIN_PET_TYPE_NAMES.OTHER,
    description: 'Small animals',
  },
];

export const DOG_TYPE_OPTIONS = [
  {
    label: `${DOG_TYPE_LABELS.SMALL_DOG} ${DOG_TYPE_INFO.SMALL_DOG}`,
    name: PET_TYPE_NAMES.SMALL_DOG,
    value: PET_TYPE_NAMES.SMALL_DOG,
  },
  {
    label: `${DOG_TYPE_LABELS.MEDIUM_DOG} ${DOG_TYPE_INFO.MEDIUM_DOG}`,
    name: PET_TYPE_NAMES.MEDIUM_DOG,
    value: PET_TYPE_NAMES.MEDIUM_DOG,
  },
  {
    label: `${DOG_TYPE_LABELS.LARGE_DOG} ${DOG_TYPE_INFO.LARGE_DOG}`,
    name: PET_TYPE_NAMES.LARGE_DOG,
    value: PET_TYPE_NAMES.LARGE_DOG,
  },
  {
    label: `${DOG_TYPE_LABELS.GIANT_DOG} ${DOG_TYPE_INFO.GIANT_DOG}`,
    name: PET_TYPE_NAMES.GIANT_DOG,
    value: PET_TYPE_NAMES.GIANT_DOG,
  },
];

export const OTHER_PET_OPTIONS = [
  {
    label: PET_TYPE_LABELS.BIRD,
    name: PET_TYPE_NAMES.BIRD,
    value: PET_TYPE_NAMES.BIRD,
  },
  {
    label: 'Rabbit or Guinea Pig',
    name: PET_TYPE_NAMES.RABBIT,
    value: PET_TYPE_NAMES.RABBIT,
  },
];
